import Response from './response'

const cards = {
  response: { component: Response }
}

export default cards
